﻿import { DateTime, Duration } from "luxon";

class PresalesCountdownItem {
    constructor(el, index) {

        this.render(el, index);
    }

    render(el, index) {
        this.el = el;

        this.refs = {            
            days: "presales-countdown-days",
            hours: "presales-countdown-hours",
            minutes: "presales-countdown-minutes",
            seconds: "presales-countdown-seconds"
        }

        this.timerPanel = document.querySelector(`[data-ref='presales-countdown-panel']`);
        this.completePanel = document.querySelector(`[data-ref='presales-countdown-complete']`);

        this.daysField = document.querySelector(`[data-ref='${this.refs.days}']`);
        this.hoursField = document.querySelector(`[data-ref='${this.refs.hours}']`);
        this.minutesField = document.querySelector(`[data-ref='${this.refs.minutes}']`);
        this.secondsField = document.querySelector(`[data-ref='${this.refs.seconds}']`);

        var endDateString = this.el.getAttribute('data-enddate');
        this.endTime = DateTime.fromISO(endDateString, { setZone: true })

        this.init();

    }

    currentTime() {
        return DateTime.local().set({ milliseconds: 0 })
    }

    finished() {
        return this.currentTime() >= this.endTime;
    }

    showTimerPanel() {
        this.timerPanel.removeAttribute('hidden');
        this.completePanel.setAttribute('hidden', 'hidden')
    }
    showEndScreen() {
        this.timerPanel.setAttribute("hidden", 'hidden');
        this.completePanel.removeAttribute('hidden');
    }
    countdownComplete() {
        if (this.interval) {
            clearInterval(this.interval);
        }
        this.showEndScreen();
    }


    updateTime() {

        var diff = this.endTime.diff(this.currentTime()).toObject();
        var duration = Duration.fromObject(diff);       
        var totalstring = duration.toFormat('dd hh mm ss').split(' ');

        this.daysField.textContent = totalstring[0];
        this.hoursField.textContent = totalstring[1];
        this.minutesField.textContent = totalstring[2];
        this.secondsField.textContent = totalstring[3];
    }

    init() {
        this.showTimerPanel();
        this.updateTime();
        if (this.interval) {
            clearInterval(this.interval);
        }

        this.interval = setInterval(() => {

            if (!this.finished()) {
                this.updateTime()
            } else {
                this.countdownComplete();
            }
        }, 1000);
    }
}

class PresalesCountdown {
    constructor(selector, element) {
        this.all = element.querySelectorAll(selector);
        for (var i = 0; i < this.all.length; i++) {
            this.render(this.all[i], i);
        }
    }

    render(el, index) {
        new PresalesCountdownItem(el, index);
    }
}


export default PresalesCountdown;